import { IGroupSeason } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import { GetGroupSeasonsPayload } from "@grassrootly/api/gateways";
import server from "../Server";

export const GetGroupSeasons = async (payload: GetGroupSeasonsPayload): Promise<IGroupSeason[]> => {
  const seasons = withErrorCheck(
    await server
      .from("group_seasons_view")
      .select("*")
      .eq("group_id", payload.groupId)
      .order("season_is_active", { ascending: false })
      .order("season_summary", { ascending: true })
  );

  return seasons || [];
};
